import { make } from 'vuex-pathify';
import { DelinquencyCollateralAssignment } from '../services/delinquency-collateral-assignment.service.js';
import Logger from '@/lib/logger';

const service = new DelinquencyCollateralAssignment();

const state = {
  collateralAssigned: [],
  collateralAssignedReport: {}
};

const mutations = make.mutations(state);

const actions = {

  async assignDelinquencyCollateral(_, payload) {
    try {
      const { data: res } = await service.assignDelinquencyCollateral(payload);
      return res;
    } catch (error) {
      Logger.error('Creating Delinquency Collateral Assignment');
      throw error;
    }
  },

  async updateDelinquencyCollateralAssignment(_, { collateralId, status }) {
    try {
      const { data: res } = await service.updateDelinquencyCollateralAssignment(collateralId, status);
      return res;
    } catch (error) {
      Logger.error('Updating Delinquency Collateral Assignment');
      throw error;
    }
  },
  

  async updateDelinquencyCollateralAssignmentInformation(_, { id, data }) {
    try {
      const { data: res } = await service.updateDelinquencyCollateralAssignmentInformation(id, data);
      return res;
    } catch (error) {
      Logger.error('Updating Delinquency Collateral Assignment Information');
      throw error;
    }
  },

  async unAssignDelinquencyCollateralAssignments(_, ids) {
    try {
      const { data } = await service.unAssignDelinquencyCollateralAssignments (ids);
      return data;
    } catch (error) {
      Logger.error('De-assigning Delinquency Collateral Assignment');
      throw error;
    }
  },

  async findDelinquencyCollateralAssignment({commit}, filters) {
    try {
      const { data } = await service.findDelinquencyCollateralAssignmentByCollateralId(filters);
      commit('SET_COLLATERAL_ASSIGNED', data.data);
      return data.data;
    } catch (error) {
      Logger.error('Finding Delinquency Collateral Assignment By Collateral Id');
      throw error;
    }
  },

  async fetchDelinquentCollateralAssignmentReport({commit}, externalParticipantId) {
    try {
      const { data } = await service.fetchDelinquentCollateralAssignmentReport(externalParticipantId);
      commit('SET_COLLATERAL_ASSIGNED_REPORT', data);
      return data;
    } catch (error) {
      Logger.error('Finding Delinquency Collateral Assignment Report');
      throw error;
    }
  },

};

export default {
  state,
  mutations,
  actions
};